export const RoutePathConstants = {
  List: "list",
  Add: "add",
  Edit: "edit",
  PasswordSet: "set-password",
  ForgotPassword: "forgotPassword",
  PasswordReset: "resetPassword",
  Login: "login",
  User: "user",
  Calendar: "calendar",
  CalendarForm: "calendar/form",
  Question: "question",
  Questionnaire: "questionnaire",
  Page: "page",
  Meetings: "meetings",
  Survey: "survey",
  ApplicationForm: "applicationForm",
  ContractForm: "contractForm",
  ContractFormv2: "contractFormv2",
  CompletingBalanceSheetOfModuleFirst: "completingBalanceSheetOfModuleFirst",
  CompletingBalanceSheetOfModuleFirstByAdvisor:
    "completingBalanceSheetOfModuleFirstByAdvisor",
  Store: "store",
  StoreSummary: "storeSummary",
  StoreEdit: "storeEdit",
  StoreExclusive: "exclusive-offer",
  StoreExclusiveSummary: "storeExclusiveSummary",
  CompletingBalanceSheetOfModuleSecond: "completingBalanceSheetOfModuleSecond",
  CompletingBalanceSheetOfModuleSecondv2: "CompletingBalanceSheetOfModuleSecondv2", 
  OrderingVouchers: "orderingVouchers",
  KnowledgeBase: "knowledgeBase",
};
